import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    getStaff(farmId, season = '', includeManagers = false) {

        const options = {
            method: 'get',
            url: `/umbraco/api/staff/get?farmId=${farmId}&includeManagers=${includeManagers}&season=${season}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    update(staff) {

        const options = {
            method: 'put',
            url: `/umbraco/api/staff/Update`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: staff
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    add(staff) {

        const options = {
            method: 'post',
            url: `/umbraco/api/staff/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: staff
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    addStaffToFarm(staffId, farmId) {
        const options = {
            method: 'put',
            url: `/umbraco/api/staff/AddStaffToFarm?staffId=${staffId}&farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingle(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/staff/getsingle?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    staffExists(firstName, lastName, farmId) {

        const options = {
            method: 'get',
            url: `/umbraco/api/staff/staffExists?firstName=${firstName}&lastName=${lastName}&farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingleReadOnly(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/staff/GetDetailReadyOnly?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getSummary(farmId, date) {

        const options = {
            method: 'get',
            url: `/umbraco/api/staff/GetSummary?farmId=${farmId}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getTrainingSummary(farmId, date) {

        const options = {
            method: 'get',
            url: `/umbraco/api/staff/GetTrainingSummary?farmId=${farmId}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getResponsibilitiesSummary(farmId, date) {

        const options = {
            method: 'get',
            url: `/umbraco/api/staff/GetResponsibilitiesSummary?farmId=${farmId}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    updateStaffResponsibility(staff) {

        const options = {
            method: 'put',
            url: `/umbraco/api/staff/UpdateStaffResponsibility`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: staff
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getTrainingForStaff(farmId, staffId) {

        const options = {
            method: 'get',
            url: `/umbraco/api/stafftraining/GetByStaff?farmId=${farmId}&staffId=${staffId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    updateStaffTraining(staffTrainingItem) {

        const options = {
            method: 'put',
            url: `/umbraco/api/stafftraining/Update`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: staffTrainingItem
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    addStaffTraining(staffTrainingItem) {

        const options = {
            method: 'post',
            url: `/umbraco/api/stafftraining/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: staffTrainingItem
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    deleteStaffTraining(staffTrainingItems) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/stafftraining/Delete`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: staffTrainingItems
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    delete(id, farmId, sad, discussion, endDate) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/staff/delete?id=${id}&farmId=${farmId}&sad=${sad}&discussion=${discussion}&endDate=${endDate}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}